"use client";

import { useState } from "react";
import QuocTeProgramList from "@/components/page/QuocTe/ProgramList/QuocTeProgramList";

interface Program {
  id: number;
  number: string;
  title: string;
  description: string;
}

interface ProgramsData {
  bachelor: Program[];
  master: Program[];
  doctorate: Program[];
}

interface Props {
  programs: ProgramsData;
}

export default function QuocTeProgramsTabs({ programs }: Props) {
  const [activeTab, setActiveTab] = useState<"bachelor" | "master" | "doctorate">("bachelor");

  return (
    <>
      <nav aria-label="Danh mục chương trình quốc tế">
        <ul className="intl-programs__tabs" role="tablist">
          <li>
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "bachelor"}
              className={`intl-programs__tab ${activeTab === "bachelor" ? "intl-programs__tab--active" : ""}`}
              onClick={() => setActiveTab("bachelor")}
            >
              Chương Trình Cử Nhân
            </button>
          </li>
          <li>
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "master"}
              className={`intl-programs__tab ${activeTab === "master" ? "intl-programs__tab--active" : ""}`}
              onClick={() => setActiveTab("master")}
            >
              Chương Trình Thạc Sĩ
            </button>
          </li>
          <li>
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "doctorate"}
              className={`intl-programs__tab ${activeTab === "doctorate" ? "intl-programs__tab--active" : ""}`}
              onClick={() => setActiveTab("doctorate")}
            >
              Chương Trình Tiến Sĩ
            </button>
          </li>
        </ul>
      </nav>

      <div className="intl-programs__content">
        {activeTab === "bachelor" && (
          <div className="intl-programs__panel intl-programs__panel--active">
            <QuocTeProgramList programs={programs.bachelor} />
          </div>
        )}
        {activeTab === "master" && (
          <div className="intl-programs__panel intl-programs__panel--active">
            <QuocTeProgramList programs={programs.master} />
          </div>
        )}
        {activeTab === "doctorate" && (
          <div className="intl-programs__panel intl-programs__panel--active">
            <QuocTeProgramList programs={programs.doctorate} />
          </div>
        )}
      </div>
    </>
  );
}
